<template>
  <div class="container-fluid">
    <booking-form
      :property-mutator="setBookingPropertyMutator"
      :duplicated="true"
      :validation-triggered=false
      :booking="booking">
    </booking-form>

    <div class="dashboard-block">
      <ladda-button
        :click="handleDuplicateBookingCallback"
        class="btn btn-primary">
        <slot name="button"/>
      </ladda-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { omit, merge, map } from 'lodash'
import { helpers } from 'mixins/bookings'
import { notify } from 'utils'
import BookingForm from 'components/booking/BookingForm'
import BookingDuplicateShortlist from 'components/booking/BookingDuplicateShortlist'

export default {
  props: {
    booking: {
      required: true,
      type: Object
    },
    setBookingAction: {
      required: true,
      type: Function
    },
    setBookingPropertyMutator: {
      required: true,
      type: Function
    }
  },

  mixins: [helpers],

  components: {
    BookingForm,
    BookingDuplicateShortlist
  },

  computed: {
    ...mapState('shortlist', ['shortlist']),
    ...mapState('booking/request', ['formStatus'])
  },

  data () {
    return {
      validationTriggered: false
    }
  },

  methods: {
    ...mapActions('booking', ['duplicateBooking']),
    ...mapActions('booking/file', ['storeBookingFile']),

    validateAll () {
      this.validationTriggered = true
      if (this.formStatus) {
        return Promise.resolve()
      } else {
        return Promise.reject(new Error('The form has validation errors'))
      }
    },

    fileUpload (id, files) {
      if (!files.length) {
        return Promise.resolve()
      } else {
        return Promise.all(files.map(file => {
          this.storeBookingFile({ id: id, file: file })
            .catch(() => {
              notify.error('Something went wrong uploading your file. Please try again.')
            })
        }))
          .then(Promise.resolve())
          .catch(Promise.reject(new Error('Something went wrong when uploading the file')))
      }
    },

    handleDuplicateBookingCallback () {
      return this.validateAll().then((response) => {
        const payload = merge(
          omit(this.booking, ['client', 'opportunity', 'talent', 'talent_notified', 'online_opportunity']),
          {
            shortlist: map(this.shortlist, talent => ({ id: talent.id }))
          }
        )

        let isOffer = false
        return this.duplicateBooking({ id: this.booking.id, payload })
          .then((response) => {
            isOffer = !!response.data.is_offer
            this.setBookingAction(response.data)
            if (payload.files && payload.files.length) {
              this.fileUpload(response.data.id, payload.files)
                .then(() => {
                  notify.success('Files uploaded successfully')
                })
            }
          })
          .then(() => {
            notify.success('Booking successfully duplicated.')
            if (this.$userIsAdmin || this.$userIsManager || this.$userIsClient) {
              this.$router.push({
                name: (isOffer ? 'bookings.show' : 'vetting.show'),
                params: { id: this.booking.id }
              })
            } else {
              this.$router.push({ name: 'requests.show', params: { id: this.booking.id } })
            }
          })
      }).catch(() => {
        notify.error('There were form validation issues, please fix them and try again.')
        return Promise.resolve()
      })
    }
  }
}
</script>
